<div class="completion-container">
    <ng-container [ngSwitch]="data?.mode">
        <ng-container *ngSwitchCase="'group-class'">
            <wizard-class-completion></wizard-class-completion>
        </ng-container>
        <ng-container *ngSwitchCase="'class-change-attendees'">
            <wizard-class-completion [isUpdating]="true"></wizard-class-completion>
        </ng-container>
        <ng-container *ngSwitchDefault>
            <div class="content content--booked" *ngIf="meetingCreateStatus === 'booked'">
                <div class="header">Your meeting has been booked!</div>
                <p class="body">
                    I've sent everyone a calendar invite. <br />
                    <ng-container *ngIf="!isPlugin">
                        You can update this meeting in the <a href="/tasks/upcoming">Upcoming Tasks</a> page.
                    </ng-container>
                </p>
                <img class="ui image" src="/assets/images/meeting-booked.svg" />
            </div>
            <div class="content content--scheduled" *ngIf="meetingCreateStatus === 'scheduled'">
                <div class="header">Your meeting invitations have been sent!</div>
                <p class="body">
                    When the meeting is booked attendees will receive an email and calendar update.<br />
                    <ng-container *ngIf="!isPlugin">
                        You can track the status of your meeting in the
                        <a href="/tasks/active">Active Tasks</a> page.
                    </ng-container>
                </p>
                <img class="ui image" src="/assets/images/invites-sent.svg" />
            </div>
            <div class="content link-generated" *ngIf="meetingCreateStatus === 'link-generated'">
                <div class="header">Your Private Invite Link is Ready!</div>
                <p class="body strong">Please click the URL below to copy your link.</p>
                <span
                    #inviteLink
                    class="invite-link"
                    data-position="bottom center"
                    (click)="handleCopyLink(wizardService.responseData.schedulingLink)"
                >
                    {{ wizardService.responseData.schedulingLink }}
                </span>
                <p class="body">
                    Your link is unique to this meeting and should only be shared with those invitees added to this
                    meeting.
                    <ng-container *ngIf="!isPlugin">
                        Once you share your link, go to <a href="/tasks/active">Active Tasks</a> to track the meeting
                        progress.
                    </ng-container>
                    <a href="https://faq.calendarhero.com/hc/en-us/articles/4430390584987-How-do-Private-Invite-Links-work-" target="_blank"
                        >Learn More</a
                    >
                </p>

                <img class="ui image margin-top-30" src="/assets/images/invites-sent.svg" />
            </div>
        </ng-container>
    </ng-container>
</div>
